
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { setCookie } from '@/utils/cookieUtils';

interface CookieConsentBannerProps {
  onClose: () => void;
}

const CookieConsentBanner: React.FC<CookieConsentBannerProps> = ({ onClose }) => {
  const { t } = useTranslation('gdpr');
  const navigate = useNavigate();
  
  const handleAccept = () => {
    // Set cookie for 365 days
    setCookie('cookie-consent', 'accepted', 365);
    onClose();
  };
  
  const handleDecline = () => {
    // Set cookie for 30 days (we'll still ask again after this period)
    setCookie('cookie-consent', 'declined', 30);
    onClose();
  };
  
  const handleLearnMore = () => {
    navigate('/cookie-policy');
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t p-4 z-50">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="space-y-2 flex-1">
            <h3 className="font-semibold text-lg">{t('cookieTitle')}</h3>
            <p className="text-sm text-gray-600">{t('cookieMessage')}</p>
            <p className="text-xs text-gray-500">{t('cookieExplanation')}</p>
          </div>
          <div className="flex gap-2 flex-wrap">
            <Button variant="outline" size="sm" onClick={handleLearnMore}>
              {t('learnMore')}
            </Button>
            <Button variant="outline" size="sm" onClick={handleDecline}>
              {t('decline')}
            </Button>
            <Button size="sm" onClick={handleAccept} className="bg-[#E4002B] hover:bg-[#C7001E] text-white">
              {t('accept')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
